var _style, _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.CameraHide-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\r\n\t\t.CameraHide-st1 {\r\n\t\t\tfill: currentColor;\r\n\t\t\tfill-opacity: 0.3;\r\n\t\t}\r\n\r\n\t\t.CameraHide-st2 {\r\n\t\t\tfill: #666666;\r\n\t\t}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "CameraHide-st0",
    d: "M12,8.1c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C16.4,10.1,14.5,8.1,12,8.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "CameraHide-st1",
    d: "M21.8,6.3h-5.2l-1.1-3.1H8.5L7.4,6.3H2.2C2.1,6.3,2,6.4,2,6.5v12.6c0,0.1,0.1,0.2,0.2,0.2h19.5 c0.1,0,0.2-0.1,0.2-0.2V6.5C22,6.4,21.9,6.3,21.8,6.3z M12,17c-2.5,0-4.4-2-4.4-4.4c0-2.5,2-4.4,4.4-4.4s4.4,2,4.4,4.4 C16.4,15,14.5,17,12,17z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "CameraHide-st0",
    d: "M21.8,4.3H18l-0.9-2.5c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2H7.7C7.4,1.2,7,1.5,6.9,1.8L6,4.3H2.2 C1,4.3,0,5.3,0,6.5v12.6c0,1.2,1,2.2,2.2,2.2h19.5c1.2,0,2.2-1,2.2-2.2V6.5C24,5.3,23,4.3,21.8,4.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "CameraHide-st2",
    d: "M12,8.1c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C16.4,10.1,14.5,8.1,12,8.1z M12,15.2 c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7C14.7,14,13.5,15.2,12,15.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8,
    y: -2.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.418 11.9132)",
    className: "CameraHide-st2",
    width: 1.8,
    height: 30.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraHide);
export default __webpack_public_path__ + "static/media/CameraHide.d74749c088007b43c352903cdec93060.svg";
export { ForwardRef as ReactComponent };